module.exports = __webpack_public_path__ + "img/1.0c3c8b18.png";